module.exports = "/images/icon-xls.svg?191338b7a26010a21727b233db6adde3";